import axios from "axios";
import { takeLatest, put } from "redux-saga/effects";

import { API_BASE_URI } from "../ApiCall";
import { ManpowerOvertimeActionTypes } from "./ManpowerOvertime.type";

export function* fetchAllManpowerOvertime(action: any): any {
  try {
    const response = yield axios.get(
      `${API_BASE_URI}/manpower_overtime?project_id=${action.payload.project_id}`
    );
    yield put({
      type: ManpowerOvertimeActionTypes.FETCH_ALL_MANPOWER_OVERTIME_SUCCESS,
      payload: response.data,
    });
  } catch (error) {
    yield put({
      type: ManpowerOvertimeActionTypes.FETCH_ALL_MANPOWER_OVERTIME_FAILURE,
      payload: error,
    });
  }
}

export function* watcherFetchAllManpowerOvertime() {
  yield takeLatest(
    ManpowerOvertimeActionTypes.FETCH_ALL_MANPOWER_OVERTIME,
    fetchAllManpowerOvertime
  );
}
